import { render, staticRenderFns } from "./Feature6.vue?vue&type=template&id=184ce148&"
import script from "./Feature6.vue?vue&type=script&lang=js&"
export * from "./Feature6.vue?vue&type=script&lang=js&"
import style0 from "./Feature6.vue?vue&type=style&index=0&id=184ce148&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports